import React, { forwardRef } from 'react';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import FormatQuote from '@material-ui/icons/FormatQuote';

const TypeQuote = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <FormatQuote {...props} ref={ref} />
));

TypeQuote.displayName = 'TypeQuote';

export default TypeQuote;
